import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Constants } from '../helpers';
import { SupplierModel } from '../models';
import { BaseService } from './base.service';

@Injectable()
export class SupplierService extends BaseService<SupplierModel> {
	constructor(httpClient: HttpClient) {
		super(httpClient, Constants.END_POINTS.supplier, SupplierModel);
	}
}
